class ExpandDescription extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('.expand-description-content');
    this.toggle = this.querySelector('.expand-description-toggle');
    this.collapsedClass = 'expand-description-content--collapsed';
    this.chevron = this.querySelector('.icon-chevron-down');
    this.resizeObserver = null;
  }

  connectedCallback() {
    if (!this.toggle || !this.content) return;

    this.init();

    this.resizeObserver = new ResizeObserver(() => {
      this.init();
    });
    this.resizeObserver.observe(this.content);

    this.toggle.addEventListener('click', this.onToggle.bind(this));
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  init() {
    if (this.toggle.getAttribute('aria-expanded') === 'true') return;

    this.content.classList.add(this.collapsedClass);
    const isOverflowing = this.content.scrollHeight > this.content.offsetHeight;
    
    this.toggle.classList.toggle('hidden', !isOverflowing);
    if (!isOverflowing) this.content.classList.remove(this.collapsedClass);
  }

  onToggle() {
    const isExpanded = this.toggle.getAttribute('aria-expanded') === 'true';
    const newState = !isExpanded;

    this.toggle.setAttribute('aria-expanded', newState);
    this.content.classList.toggle(this.collapsedClass, !newState);
    
    this.querySelector('.toggle-text-more').classList.toggle('hidden', newState);
    this.querySelector('.toggle-text-less').classList.toggle('hidden', !newState);
    this.chevron.classList.toggle('rotate-180', newState);
  }
}

if (!customElements.get('expand-description')) {
  customElements.define('expand-description', ExpandDescription);
}
